import { cbi_water_sub_type_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateCbiWaterSubTypeEnum = (enumValue: cbi_water_sub_type_enum) => {
  switch (enumValue) {
    case cbi_water_sub_type_enum.DRINKING_WATER:
      return <Trans i18nKey="Enum_CbiWaterSubTypeEnum-DRINKING_WATER" />;
    case cbi_water_sub_type_enum.RAINWATER:
      return <Trans i18nKey="Enum_CbiWaterSubTypeEnum-RAINWATER" />;
    case cbi_water_sub_type_enum.WASTEWATER:
      return <Trans i18nKey="Enum_CbiWaterSubTypeEnum-WASTEWATER" />;
  }
};

export const translateCbiWaterSubTypeEnum_dynamic = (enumValue: cbi_water_sub_type_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case cbi_water_sub_type_enum.DRINKING_WATER:
      return t('Enum_CbiWaterSubTypeEnum-DRINKING_WATER');
    case cbi_water_sub_type_enum.RAINWATER:
      return t('Enum_CbiWaterSubTypeEnum-RAINWATER');
    case cbi_water_sub_type_enum.WASTEWATER:
      return t('Enum_CbiWaterSubTypeEnum-WASTEWATER');
  }
};
